/* Shows selected colour name below the swatches, updates on change.
   Handles the swatch swap rebuilding the form by re-applying after it settles. */
(function () {
  function initFieldset(fs) {
    if (fs.dataset.nameBound) return;
    fs.dataset.nameBound = '1';

    var nameEl = document.createElement('div');
    nameEl.className = 'etq-swatch-name';
    fs.appendChild(nameEl);

    function update() {
      var checked = fs.querySelector('input[type="radio"]:checked');
      nameEl.textContent = checked ? checked.value : '';
    }

    fs.addEventListener('change', update);
    fs.addEventListener('input', update);
    fs.addEventListener('click', function () { setTimeout(update, 30); });

    update();
  }

  function init() {
    document.querySelectorAll('.etq-color-fieldset').forEach(initFieldset);
  }

  // Re-apply the name after a colour change, in case the form rebuilds and wipes it
  function reapply() {
    document.querySelectorAll('.etq-color-fieldset').forEach(function (fs) {
      var nameEl = fs.querySelector('.etq-swatch-name');
      if (!nameEl) {
        delete fs.dataset.nameBound;
        initFieldset(fs);
        return;
      }
      var checked = fs.querySelector('input[type="radio"]:checked');
      if (checked) nameEl.textContent = checked.value;
    });
  }

  // Initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);
  setTimeout(init, 500);
  setTimeout(init, 1500);
  document.addEventListener('shopify:section:load', init);

  // Handle swatch swaps that rebuild the form
  document.addEventListener('change', function (e) {
    if (e.target.closest('.etq-color-fieldset')) {
      setTimeout(reapply, 50);
      setTimeout(reapply, 250);
      setTimeout(reapply, 600);
    }
  });
  document.addEventListener('variant:change', reapply);
  document.addEventListener('shopify:section:load', function () { setTimeout(reapply, 100); });
})();